import { Controller } from 'stimulus';
import Swiper, { Pagination } from 'swiper';

class Slider extends Controller {
  connect() {
    Swiper.use([Pagination]);

    this.swiper = new Swiper(this.element, {
      slidesPerView: 1,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'custom',
        renderCustom(swiper, current, total) {
          const count = `${current}/${total}`;

          const barWidth = 100 / total;
          const barLeftOffset = barWidth * (current - 1);

          return `
            <div class="slider__pagination">
                <span class="slider__pagination-count">${count}</span>
                <div class="slider__pagination-bar">
                    <span style="left: ${barLeftOffset}%; width: ${barWidth}%"></span>
                </div>
            </div>
          `;
        },
      },
    });
  }
}

export default Slider;
